import React from "react";
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(",")
    },

    palette: {
      contrastThreshold: 2,
      primary: {
        // --color-primary (navy-500)
        main: "#2A449A",
        dark: "#122E8C",
        light: "#9BA8D6",
        contrastText: "#ffffff"
      },
      secondary: {
        // --color-secondary (navy-700)
        main: "#122150",
        contrastText: "#ffffff"
      },
      error: {
        // --color-danger (red-500)
        main: "#D92D20",
        light: "#F97066",
        dark: "#B42318"
      },
      warning: {
        // --color-warning (gold-500)
        main: "#EEA005",
        light: "#FFCF5C",
        dark: "#996E1F",
        contrastText: "#101B3D"
      },
      success: {
        // --color-success (green-500)
        main: "#008A5E",
        light: "#6FBFA2",
        dark: "#006B49",
        contrastText: "#ffffff"
      },
      info: {
        // --color-info (teal-500)
        main: "#0D578C",
        light: "#6FA3C4",
        dark: "#0A456E",
        contrastText: "#ffffff"
      }
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: true // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1
      }
    }
  }
);

export default function ThemeProvider(props) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
